import {Link} from "react-router";
import {getColumnSearchProps} from "../widget/SearchProps";
import {InvoiceStateWidget} from "../sales/InvoiceStateWidget";
import {Table} from 'antd';
import {useRef} from "react";
import {clampToCents} from "../../util/unitutils";

export const InvoiceTable = ({invoice, props}) => {
    // for use with search props
    const searchInput = useRef(null);

    const columns = [
        {
            title: 'Invoice Number',
            dataIndex: 'invoiceNumber',
            key: 'invoiceNumber',
            render: (val, record, index) => {
                return <Link to={`/invoice/${record.id}`}>{val}</Link>
            },
            ...getColumnSearchProps(`invoiceNumber`, searchInput),
            sorter: (a, b) => a.invoiceNumber.toLowerCase().localeCompare(b.invoiceNumber.toLowerCase()),
        },
        {
            title: 'Buyer',
            dataIndex: 'firstname',
            render: (val, record, index) => {
                return `${val} ${record.lastname}`
            },
            ...getColumnSearchProps(`firstname`, searchInput),
            sorter: (a, b) => {
                const aName = `${a.firstname} ${a.lastname}`;
                const bName = `${b.firstname} ${b.lastname}`;
                return aName.localeCompare(bName);
            }
        },
        {
            title: 'Created by',
            dataIndex: 'username',
            key: 'username',
            sorter: (a, b) => a.username.localeCompare(b.username)
        },
        {
            title: 'Date',
            dataIndex: 'timestamp',
            key: 'timestamp',
            render: (val) => {
                const terms = val.split("T");
                return terms[0]
            },
            sorter: (a, b) => (new Date(a.timestamp))- (new Date(b.timestamp)),
        },
        {
            title: 'Status',
            dataIndex: 'state',
            key: 'state',
            render: (val, record, index) => {
                // return InvoiceStatusType.Label[val];
                return <InvoiceStateWidget invoice={record} disabled={true} />
            },
            sorter: (a, b) => a.state - b.state
        },
        {
            title: 'Subtotal',
            dataIndex: 'subtotal',
            key: 'subtotal',
            render: (val) => {
                return `$ ${val}`;
            },
            sorter: (a, b) => a.subtotal - b.subtotal,
        },
        {
            title: 'Cost',
            dataIndex: 'totalCost',
            key: 'cost',
            render: (val, record, index) => {
                return <div>$ {val}</div>
            },
            sorter: (a, b) => a.totalCost - b.totalCost,
        },
        {
            title: 'Profit',
            dataIndex: 'profit',
            key: 'cost',
            render: (val, record, index) => {
                const profit = clampToCents(record.amountPaid-record.totalCost);
                let color = "black";
                if (profit > 0) {
                    color="green"
                } else if (profit < 0) {
                    color = "red";
                }
                return <div style={{color}}>$ {profit}</div>
            },
        },
        {
            title: 'Paid',
            dataIndex: 'amountPaid',
            key: 'amountPaid',
            render: (val, record, index) => {
                return <div>$ {val}</div>;
            },
            sorter: (a, b) => a.amountPaid - b.amountPaid,
        },
        // {
        //     title: 'Balance',
        //     dataIndex: 'subtotal',
        //     key: 'balance',
        //     render: (val, record, index) => {
        //         return `$ ${record.subtotal - record.amountPaid}`
        //     },
        //     sorter: (a, b) => {
        //         const aBalance = a.subtotal - a.amountPaid;
        //         const bBalance = b.subtotal - b.amountPaid;
        //         return aBalance - bBalance;
        //     },
        // },
    ];

    const tablePagination = {
        defaultPageSize: 30,
        pageSizeOptions: [30, 60, 90, 120]
    }
    return <Table dataSource={invoice} columns={columns} pagination={tablePagination}/>
}